import React, { useContext, useEffect, useRef, useState } from "react";
import "./AdminProfile.css";
import { toast } from "react-toastify";
import { API } from "../../constants/Api";
import { ProfileUpdate } from "../../App";
import DataTable from "react-data-table-component";
function AddAdmin() {
  const { profileUpdateState, setProfileUpdateState } =
    useContext(ProfileUpdate);
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const adminId = localStorage.getItem("adminId");

  const [adminEmail, setEmail] = useState("");
  const [adminPhone, setPhone] = useState("");
  const [update, setUpdate] = useState("");
  const [name, setName] = useState("")
  const adminName = localStorage.getItem("adminName");
  const imageRef = useRef(null);
   const [data, setData] = useState([]); // Combined data for tours and offers
  const token = localStorage.getItem("token");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState("Create New Admin");
  const handleImageButton = () => {
    if (imageRef) {
      imageRef.current.click();
    }
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

    useEffect(() => {
      const fetchData = async () => {
        setLoading(true)
        try {
          const response = await fetch(
            `${API}/auth/admins/get-allAdmins`,{
              headers: { Authorization: `Bearer ${token}`, },
            }
          );
          const json = await response.json();
  
          if (response.ok) {
            setData(json || []);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      };
  
  
  
        fetchData();
   
      // fetchData2()
      // fetchData()
    }, [update, token, activeTab]);

    function validation() {
  
  
      if (adminEmail.length < 1) {
        toast.error("Email is required");
        return false;
      }
      if (name.length < 1) {
        toast.error("Name is required");
        return false;
      }
  
      if (password.length < 1) {
        toast.error("Password required");
        return false;
      }

      if (password.length > 1) {
        if(password !== confirmPassword){
          toast.error("Passwords does not match");
          return false;
        }
    
      }
      if (adminPhone.length > 10) {
        toast.error("Phone length should be under 11");
        return false;
      }
  
  
      return true;
    }
  
    const handleSignUp = async (e) => {
      e.preventDefault();
  
      const validate = await validation();
  
      if (validate) {
        const formData = new FormData();
  
      
        formData.append("email", adminEmail);
        formData.append("name", name);
        if(image){
          formData.append("image", image);
        }
      
          formData.append("password", password);
          formData.append("role", "admin");
      
        setLoading(true);
        const toastLoading = await toast.loading("creating admin...");
        try {
      
          const response = await fetch(`${API}/auth/admins/admin-register`, {
            method: "POST",
            body: formData,
            headers: {
              "Authorization": `Bearer ${token}`
            }
          });
          const json = await response.json();
          if (response.ok) {
            toast.dismiss(toastLoading);
            toast.success("Admin created seccessfully");
            setLoading(false);
    
     
            setProfileUpdateState(profileUpdateState + 1)
  
          } else {
            setLoading(false);
            toast.dismiss(toastLoading);
            toast.error(json.message);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          toast.dismiss(toastLoading);
          setLoading(false);
          
          setImage(null)
        }
      }
    };
    const deleteAdmin = async (id) => {

      const newLoading = toast.loading("deleting admin...")
      try{
        const response = await fetch(`${API}/auth/admins/delete-admin/${id}`, {
          method: "DELETE",
          
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });
        const json = await response.json();
        if(response.ok){
          toast.success(json.message)
        }

      }catch(error){
        toast.error(error.message)
      }finally{

        toast.dismiss(newLoading)
      }
    }
    const columns = [
      {
        name: "Name",
        selector: (row) => row.name,
        cell: (row) => (
          <div className="table-layout-content-header-box">
            <div className="table-layout-content-header-image">
              {row.imageUrl !== null ? (
                <>
                  {" "}
                  <img
                    src={row.imageUrl !== null ? row.imageUrl : ""}
                    className="table-layout-content-header-image-media img-fluid"
                    alt=""
                  />
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="table-layout-content-header-details">
              <h3 className="table-layout-content-header-details-name my-0">
                {row.name}
              </h3>
             
            </div>
          </div>
        ),
        sortable: true,
        minWidth: "300px",
      },
  
      {
        name: "Email",
        selector: (row) => row.email,
        sortable: true,
        minWidth: "200px",
      },
      {
        name: "Role",
        selector: (row) => row.role,
        sortable: true,
        minWidth: "200px",
      },
      {
        name: "Status",
        selector: (row) => (row.isVerified ? "Verified" : "Un verified"),
  
        sortable: true,
        minWidth: "200px",
      },
      // {
      //   name: "Action",
      //   cell: (row) => (
      //     <button className="tour-cta-1" onClick={()=>deleteAdmin(row._id)} >
      //       Delete
      //     </button>
      //   ),
      //   minWidth: "200px",
      // },
    ];
   
    // Custom styles for DataTable
    const customStyles = {
      table: {
        style: {
          backgroundColor: "#252525!important",
        },
      },
      headCells: {
        style: {
          backgroundColor: "#1e1e1e",
          color: "#ffffff",
          fontSize: "16px",
          fontFamily: "Degular-Light",
        },
      },
      cells: {
        style: {
          fontSize: "14px",
          color: "#ffffff",
        },
      },
      rows: {
        style: {
          backgroundColor: "#252525",
          fontFamily: "Degular-Light",
        },
        highlightOnHoverStyle: {
          backgroundColor: "#e3f2fd",
          transition: "0.2s ease-in-out",
        },
      },
      pagination: {
        style: {
          backgroundColor: "#1e1e1e",
          fontSize: "14px",
          borderTop: "1px solid #ddd",
          color: "#ffffff",
        },
        pageButtonsStyle: {
          color: "#ffffff",
          fill: "#ffffff",
          "&:hover": {
            backgroundColor: "#252525",
            color: "#ffffff",
            fill: "#ffffff",
          },
          "&:disabled": {
            color: "#bdbdbd",
            fill: "#bdbdbd",
          },
        },
      },
    };
  return (
    <div className="user-profile">
      <h2 className="user-layout-page-heading">Add an admin</h2>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 mt-4 px-0">
            <div className="">
              <button
                className={`btn agent-leads-tab ${activeTab === "Create New Admin" ? "active-agent-leads-tab" : ""}`}
                onClick={() => setActiveTab("Create New Admin")}
              >
                Create New Admin
              </button>
              <button
                className={`btn agent-leads-tab ${activeTab === "Manage Admins" ? "active-agent-leads-tab" : ""}`}
                onClick={() => setActiveTab("Manage Admins")}
              >
                Manage Admins
              </button>
            
            </div>
          </div>
        </div>
      </div>
      {
        activeTab === "Create New Admin"?
        <>   <div className="container-fluid mt-2">
        <div className="row">
          <div className="col-12 px-0 pt-3">
            <p className="user-profile-picture">Profile Picture</p>
          </div>
          <div className="col-12 px-0">
            <div className="user-profile-box">
              <div className="user-profile-image">
                {previewImage ? (
                  <img
                    src={previewImage}
                    className="user-layout-content-header-image-media"
                    alt=""
                  />
                ) : (
                  <></>
                )}
              </div>
              <div className="user-profile-details">
                <button
                  onClick={handleImageButton}
                  className="btn logout-button"
                >
                  Change Profile Picture
                </button>
                <input
                  type="file"
                  hidden
                  onChange={handleImageChange}
                  ref={imageRef}
                   accept="image/png, image/jpeg, image/jpg"
                />
              </div>
            </div>
          </div>
          <div className="col-12 px-0 py-1">
            <hr className="text-white" style={{ opacity: "0.05" }} />
          </div>
          <div className="col-lg-7 px-0 py-1">
            <p className="user-profile-picture">Account Details</p>
            <input
              type="text"
              className="form-control user-profile-input-field"
              id="exampleInputPassword1"
              placeholder="Name"
              value={name}

              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="email"
              className="form-control user-profile-input-field"
              id="exampleInputPassword1"
              placeholder="Email address"
              value={adminEmail}

              onChange={(e) => setEmail(e.target.value)}
            />
      
       
          </div>
          <div className="col-12 px-0 py-1">
            <hr className="text-white" style={{ opacity: "0.05" }} />
          </div>
          <div className="col-md-7 px-0 py-1">
            <p className="user-profile-picture">New Password</p>
            <input
              type="password"
              className="form-control user-profile-input-field"
              id="exampleInputPassword1"
              placeholder="New Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="col-md-7 px-0 py-3">
            <p className="user-profile-picture">Confirm Password</p>
            <input
              type="password"
              className="form-control user-profile-input-field"
              id="exampleInputPassword1"
              placeholder="Confirm Password"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <div className="col-md-7 px-0 py-3">
            <button onClick={handleSignUp} className="btn user-profile-update-button">
              Create admin
            </button>
          </div>
        </div>
      </div></>

        :
        <>
     
            <div className="container-fluid agent-buy-leads-container">
            
              <div className="row">
                {data.length > 0 ? (
                  <div className="col-12 px-0 pt-4">
                    <DataTable
                      columns={columns}
                      data={data}
                      pagination
                      paginationPerPage={4}
                      paginationRowsPerPageOptions={[4, 10, 15, 20]}
                      customStyles={customStyles}
                      progressPending={false}
                      progressComponent={
                        <div className="text-center my-2 bg-white">
                          <div
                            className="spinner-border text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      }
                      className="table table-striped table-hover"
                    />
                  </div>
                ) : (
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                    <img
                      src="/img/leadership-empty.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <h2 className="leadership-empty-heading">
                      It’s Empty here!
                    </h2>
                    <p className="leadership-empty-para mt-2">
                      Look’s like you haven’t any data to display.
                    </p>
                  </div>
                )}
              </div>
            </div>
         
        </>
      }
   
    </div>
  );
}

export default AddAdmin;
